module.exports = __webpack_public_path__ + "img/3-center.6745b8e0.png";